// @flow
import type { Action } from "../actions/types";
import {
  SET_USER,
  RESET_USER,
  FETCH_LATLNG_SUCCESS,
  FETCH_USER_DETAILS,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_ERROR,
} from "../actions/types";

export type UserState = {|
  mobile: string;
  coords: {latitude: number, longitude: number} | null;
  fetching: boolean;
  name: string;
  email: string;
|};

const initialState: UserState = {
  mobile: '',
  coords: null,
  fetching: false,
  name: '',
  email: '',
}

export const userReducer = (state: UserState = initialState, action: Action) => {
  const { type, payload = {} } =action;
  switch (type) {
    case SET_USER:
      return {
        ...state,
        ...payload
      };

    case RESET_USER:
      return {
        ...initialState
      };

    case FETCH_LATLNG_SUCCESS: 
      return {
        ...state,
        coords: action.payload
      }

    case FETCH_USER_DETAILS:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_USER_DETAILS_SUCCESS:
      return {
        ...state,
        fetching: false,
        name: payload.name,
        email: payload.email,
      };

    case FETCH_USER_DETAILS_ERROR:
     return {
       ...state,
       fetching: false,
     }
    default:
      return state;
  }
}